import { thunk } from 'easy-peasy';
import AWS from 'aws-sdk';
import AWSIAM from './config/awsIAMConfigure';
import { initAWSSDK } from '../../hooks/awsHelpers';

//Config AWS SDK S3
const S3_BUCKET = AWSIAM.bucketName;
const REGION = AWSIAM.region;
const BUCKET_NAME = process.env.REACT_APP_BUCKET;

const FileS3 = {
  //✨✨==========================================✨✨
  //            UPLOAD FILE S3
  //✨✨==========================================✨✨

  uploadFile: thunk(async (actions, payload, { getStoreActions }) => {
    await initAWSSDK();

    const s3 = new AWS.S3({
      region: REGION,
      params: { Bucket: S3_BUCKET },
    });

    const params = {
      Body: payload?.file, // Contenu du fichier
      Bucket: S3_BUCKET, // Nom du bucket
      Key: payload?.nameFile, // Chemin et nom du fichier dans le bucket
      ContentType: payload?.contentType, // Type MIME du fichier
    };

    try {
      getStoreActions().global.setActivity(true);

      // Utiliser Promises au lieu du callback
      const result = await s3.putObject(params).promise();

      console.log('Upload réussi :', result);
      return true;
    } catch (err) {
      console.error("Erreur lors de l'upload S3 :", err);
      throw new Error(`Erreur d'upload : ${err.message}`);
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),

  //✨✨==========================================✨✨
  //            DELETE FILE S3
  //✨✨==========================================✨✨
  deleteFile: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    await initAWSSDK();

    const s3 = new AWS.S3({
      region: REGION,
      params: { Bucket: S3_BUCKET },
    });

    const params = {
      Bucket: S3_BUCKET,
      Key: payload?.nameFile,
    };
    getStoreActions().global.setActivity(true);
    return s3.deleteObject(params).send((err) => {
      if (err) {
        throw err;
      } else {
        return true;
      }
    });
  }),

  //✨✨==========================================✨✨
  //            GET URL FILE S3 (IMPROVED)
  //✨✨==========================================✨✨
  getSignedUrlS3: thunk(async (actions, payload, { getStoreActions }) => {
    try {
      // Validation de l'input
      if (!payload) {
        throw new Error("Aucun fichier spécifié (payload est manquant)");
      }

      // Init AWS SDK (sécurisé)
      await initAWSSDK();

      const s3 = new AWS.S3({
        region: REGION,
        params: { Bucket: S3_BUCKET },
        signatureVersion: "v4", // 🔐 toujours préciser v4
      });

      const params = {
        Bucket: S3_BUCKET,
        Key: payload,
        Expires: payload?.expiresIn || 60, // ⏳ durée de validité (60s par défaut)
      };

      getStoreActions().global.setActivity(true);

      console.log("[S3] Génération URL signée", params);

      // On "promisifie" getSignedUrl pour un usage async/await
      const url = await new Promise((resolve, reject) => {
        s3.getSignedUrl("getObject", params, (err, signedUrl) => {
          if (err) return reject(err);
          resolve(signedUrl);
        });
      });

      console.log("[S3] URL signée générée ✅:", url);
      return url;
    } catch (error) {
      console.error("[S3] Erreur lors de la génération de l’URL signée ❌", error);
      getStoreActions().global.setError("Impossible de générer l'URL du fichier S3");
      return null;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),

  // ✨✨==========================================✨✨
  //            GET PRESIGNED URL FILE S3
  //✨✨==========================================✨✨
  getPresignedUrl: thunk(async (actions, payload, { getStoreActions }) => {
    try {
      // Validation de l'input
      if (!payload) {
        throw new Error("Aucun fichier spécifié (payload est manquant)");
      }

      let s3Key = payload;

      // Normalisation : Amplify ajoute le level lui-même
      if (s3Key.startsWith('public/')) {
        s3Key = s3Key.replace(/^public\//, '');
      }

      // Init AWS SDK (sécurisé)
      await initAWSSDK();

      const s3 = new AWS.S3({
        region: REGION,
        params: { Bucket: BUCKET_NAME },
        signatureVersion: "v4", // 🔐 toujours préciser v4
      });

      const params = {
        Bucket: BUCKET_NAME,
        Key: `public/${s3Key}`,
        Expires: payload?.expiresIn || 60, // ⏳ durée de validité (60s par défaut)
      };

      getStoreActions().global.setActivity(true);

      console.log("[S3] Génération URL signée", params);

      // On "promisifie" getSignedUrl pour un usage async/await
      const url = await new Promise((resolve, reject) => {
        s3.getSignedUrl("getObject", params, (err, signedUrl) => {
          if (err) return reject(err);
          resolve(signedUrl);
        });
      });

      console.log("[S3] URL signée générée ✅:", url);
      return url;
    } catch (error) {
      console.error("[S3] Erreur lors de la génération de l’URL d’upload ❌", error);
      return null;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),

};

export default FileS3;

